// @ts-nocheck
import { populate } from 'populate';
import type { Container, Text, Sprite } from 'pixi.js';
import { ButtonExtraLargeLayout } from '../common/buttons/ButtonExtraLargeLayout';

const raw = {
  list: [
    {
      id: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: '3cbb6f8f-474f-4b38-8a71-193ec4673c35',
      type: 'Container',
      name: 'popup',
      className: '',
      x: 332,
      y: 593,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'Rectangle',
        x: -2000,
        y: -2000,
        width: 4000,
        height: 4000
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        tapSound: 'UI_Button_Click'
      }
    },
    {
      id: '3df910f1-da12-4df1-9851-b6bb51b3a507',
      type: 'Text',
      name: 'description',
      className: '',
      x: 0,
      y: 50,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Tap on an object to hit it',
      localize: true,
      maxWidth: 600,
      maxHeight: 150,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 48,
        fontWeight: 'normal',
        fontFamily: 'Kanit{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'center',
        wordWrap: true,
        wordWrapWidth: 600,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '3cbb6f8f-474f-4b38-8a71-193ec4673c35',
      stateByName: {
        Move: {
          text: 'Swap any two stacks'
        },
        Redraw: {
          text: 'Redraw the stacks in the tray',
          localize: true
        },
        Hammer: {
          text: 'Tap on an object to hit it',
          localize: true
        }
      }
    },
    {
      id: 'cd92cd54-9226-41da-b588-2671aa88d7c9',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: -200,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 2.226087,
        y: 2.226087
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16762112,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Circle_Glow',
      parent: '3cbb6f8f-474f-4b38-8a71-193ec4673c35'
    },
    {
      id: '3828bc9a-ba2a-479f-97a9-21c0df39f8a0',
      type: 'Sprite',
      name: 'ray',
      className: '',
      x: 0,
      y: -200,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.656766,
        y: 1.65
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 15650151,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'New_Rays',
      parent: '3cbb6f8f-474f-4b38-8a71-193ec4673c35'
    },
    {
      id: '1b4d20a9-1775-4bc7-b0ec-be759ab49b49',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: -200,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.804533,
        y: 0.802292
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Booster_Button',
      parent: '3cbb6f8f-474f-4b38-8a71-193ec4673c35'
    },
    {
      id: 'a1846561-6732-4fbe-8b21-fdeb91788214',
      type: 'Sprite',
      name: 'iconShadow',
      className: '',
      x: 5,
      y: -190,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.708333,
        y: 0.749064
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16746499,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Hammer_Booster_Shadow',
      parent: '3cbb6f8f-474f-4b38-8a71-193ec4673c35',
      stateByName: {
        Move: {
          texture: 'Move_Booster_Shadow'
        },
        Redraw: {
          texture: 'Swap_Booster_Shadow'
        },
        Hammer: {
          texture: 'Hammer_Booster_Shadow',
          x: 5,
          y: -185
        }
      }
    },
    {
      id: 'b47655ed-cada-4009-aab5-160b92927919',
      type: 'Sprite',
      name: 'icon',
      className: '',
      x: 0,
      y: -200,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.708333,
        y: 0.749064
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Hammer_Booster',
      parent: '3cbb6f8f-474f-4b38-8a71-193ec4673c35',
      stateByName: {
        Move: {
          texture: 'Move_Booster'
        },
        Redraw: {
          texture: 'Swap_Booster'
        },
        Hammer: {
          texture: 'Hammer_Booster'
        }
      }
    },
    {
      id: 'c3f892d3-8cef-435b-9867-b2b6e3d50d92',
      type: 'Text',
      name: '',
      className: '',
      x: 95,
      y: -100,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'x3',
      localize: false,
      maxWidth: 200,
      maxHeight: 200,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 120,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '#000000',
        strokeThickness: 8,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '3cbb6f8f-474f-4b38-8a71-193ec4673c35',
      stateByName: {
        noFreeReward: {
          style: {
            stroke: '#484848'
          }
        }
      }
    },
    {
      id: 'e69ea18f-0ed2-417b-9cd3-41ddb9303c5d',
      type: 'Container',
      name: 'noCloseArea',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'Rectangle',
        x: -275,
        y: -450,
        width: 550,
        height: 600
      },
      parent: '3cbb6f8f-474f-4b38-8a71-193ec4673c35'
    },
    {
      id: '50a7c76d-dcfe-4ca4-9f4d-f9e3d702cfc7',
      type: 'Layout',
      name: 'buyButton',
      className: '',
      path: 'common/buttons/ButtonExtraLargeLayout.ts',
      percentX: 0,
      percentY: 0,
      handleResize: false,
      x: 0,
      y: 255,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: true,
      buttonMode: true,
      parent: '3cbb6f8f-474f-4b38-8a71-193ec4673c35',
      data: {
        color: 'green'
      }
    },
    {
      id: 'bcd92af6-250c-47ee-b425-342a7a2afd27',
      type: 'Sprite',
      name: 'closeButton',
      className: '',
      x: 0,
      y: 500,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'Overlay_Close',
      parent: '3cbb6f8f-474f-4b38-8a71-193ec4673c35'
    },
    {
      id: 'fae4aa58-613f-436e-affc-36971c89cd6f',
      type: 'Text',
      name: 'price',
      className: '',
      x: 30,
      y: -5,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '4900',
      localize: false,
      maxWidth: 230,
      maxHeight: 76,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 50,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '#006f0d',
        strokeThickness: 8,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '50a7c76d-dcfe-4ca4-9f4d-f9e3d702cfc7',
      stateByName: {
        noFreeReward: {
          style: {
            stroke: '#484848'
          }
        }
      }
    },
    {
      id: '47950141-a8f5-4212-b709-12574eb072b0',
      type: 'Sprite',
      name: '',
      className: '',
      x: -69,
      y: -1,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.3,
        y: 1.3
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'coin',
      parent: '50a7c76d-dcfe-4ca4-9f4d-f9e3d702cfc7'
    }
  ],
  x: 0,
  y: 0,
  width: 664,
  height: 1171,
  version: '1.0.0',
  stateNames: [
    'Hammer',
    'Move',
    'Redraw'
  ],
  animations: [
    {
      id: 'cb99851b-2149-45d4-8fc3-ae28bc73c237',
      name: 'Idle',
      playingSpeed: 1,
      totalDuration: 10000,
      blocks: [
        {
          id: '9eb06942-9fa3-4496-9bfa-11e2d114f34f',
          type: 'Setter',
          name: '',
          track: 0,
          target: {
            angle: 0
          },
          startAt: 0,
          sourceName: 'ray'
        },
        {
          id: '012106ba-f95c-45af-87f4-1b3006eb3b91',
          type: 'Tween',
          name: '',
          duration: 10000,
          track: 1,
          target: {
            angle: 359
          },
          startAt: 0,
          sourceName: 'ray',
          easing: 'Linear'
        }
      ]
    }
  ],
  handleResize: false
} as const;

export class BuyBoosterPopupLayout {
  static raw = raw;
  root!: Container;
  popup!: Container & { data: typeof raw['list'][1]['data'] };
  description!: Text;
  ray!: Sprite;
  iconShadow!: Sprite;
  icon!: Sprite;
  noCloseArea!: Container;
  buyButton!: ButtonExtraLargeLayout & { data: typeof raw['list'][10]['data'] };
  closeButton!: Sprite;
  price!: Text;
  StateName!: 'Hammer' | 'Move' | 'Redraw';

  constructor() {
    populate(this, raw);
  }
}

export abstract class Idle {
  Layout: {
    ray: object;
  };

  BlockTypeByName: {};

  flowData = raw.animations[0];
}
